import { render } from "./beltWayDetail.vue?vue&type=template&id=0464d4d6&scoped=true"
import script from "./beltWayDetail.vue?vue&type=script&lang=js"
export * from "./beltWayDetail.vue?vue&type=script&lang=js"

import "./beltWayDetail.vue?vue&type=style&index=0&id=0464d4d6&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0464d4d6"]])

export default __exports__